module.exports = __webpack_public_path__ + "img/stackslash-69-mobile.fd1d0608.jpg";